import { List, Datagrid, TextField,
  DateField, EditButton, ShowButton,
  FunctionField, TextInput, ListProps, AutocompleteInput} from "react-admin";
import { verifyAccess } from "../../utils/resourcePermissons";

const customersFilters = [
  <TextInput source="email" label="EMAIL" variant="standard"/>,
  <TextInput source="phone" label="PHONE" alwaysOn variant="standard" />,
  <TextInput source="first_name" label="FIRST NAME" variant="standard"/>,
  <TextInput source="last_name" label="LAST NAME" variant="standard"/>,
  <AutocompleteInput source="active" label="ACTIVE STATUS" defaultValue="true" choices={[
    { id: 'true', name: 'Active' },
    { id: 'false', name: 'Not Active' }
  ]} />
];

export const CustomersList: React.FC<ListProps> = (props) => {
  return (
    <List {...props} filters={customersFilters} exporter={false} sort={{ field: 'created_at', order: 'DESC' }}>
      <Datagrid>
        <TextField source="id" sortable={false} label="ID"/>
        <FunctionField render={(record: any) => `${record.first_name}${record.last_name ? ' ' + record.last_name : ''}`} label="Name"/>
        <TextField source="email" label="Email"/>
        <TextField source="phone" label="Phone"/>
        <TextField source="points" sortable={false} label="Points"/>
        <DateField source="created_at" label="Joined"/>
        {verifyAccess(props.permissions, 'customer', 'update') ? <EditButton /> : null}
        <ShowButton />
      </Datagrid>
    </List>
  )};